/**
 * Derived helpers for Wave with multi-entry spawners (Phase C).
 * totalMonsters / spawned are no longer direct fields — compute from spawners[].
 */

import type { Wave } from "./entities.js";

/** Total monsters this wave (sum of all spawner totals). */
export function waveTotal(w: Wave): number {
  let n = 0;
  for (const sp of w.spawners) n += sp.total;
  return n;
}

/** Monsters already spawned this wave (sum of all spawner spawned). */
export function waveSpawned(w: Wave): number {
  let n = 0;
  for (const sp of w.spawners) n += sp.spawned;
  return n;
}

/** True when all monsters for this wave have been spawned. */
export function waveDone(w: Wave): boolean {
  return waveSpawned(w) >= waveTotal(w);
}
